var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18.6036,
    height: 14,
    viewBox: "0 0 18.6036 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H18.6036V14H0V0Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.93379 1.3125L4.02768 5.1114L1.16273 2.7636H4.70485L1.8399 5.1114L2.93379 1.3125Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.35691 0.698269L6.25349 2.02466L5.64595 0.882629L6.73251 1.40417L5.58238 1.70253L6.35691 0.698269Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.96877 2.22832L7.41748 3.40546L7.25015 2.08679L8.07227 3.04343L6.9097 2.8146L7.96877 2.22832Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.76016 4.56349L6.83142 5.38438L7.15519 4.10337L7.56009 5.35536L6.58134 4.61109L7.76016 4.56349Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.36602 5.48512L6.3114 6.81521L5.66244 5.70259L6.76722 6.17283L5.62904 6.52476L6.36602 5.48512Z",
    fill: "#FFFF00"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17.6036,
    height: 13,
    stroke: "black",
    strokeOpacity: 0.12
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6036,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.183cf0e8ba15b451df5fc39438119d45.svg";
export { ForwardRef as ReactComponent };